import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/schedules')({
  component: () => <Outlet />,
});
